import { blobDownloadFile as c } from "../common/index.mjs";
const l = (e) => {
  const n = async (t, a, r, s = !0) => {
    const o = await e({
      method: a,
      headers: { Accept: "x-www-form-urlencoded" },
      responseType: "blob",
      timeout: 6e5,
      ...t
    });
    if (o.blob.type === "application/json") {
      const i = await o.blob.text(), p = JSON.parse(i);
      return Promise.reject(p);
    } else
      return s && c(o.blob, r || o.fileName || "file"), o.blob;
  };
  return {
    /** get方法 */
    get: async (t) => await e({ method: "get", ...t }),
    /** post方法 */
    post: async (t) => await e({ method: "post", ...t }),
    /** put方法 */
    put: async (t) => await e({ method: "put", ...t }),
    /** delete方法 */
    delete: async (t) => await e({ method: "delete", ...t }),
    /** 导出图片 */
    exportImage: async (t) => await e({ method: "get", responseType: "arraybuffer", ...t }),
    /** 导出文件,get方法 */
    exportFileGet: async (t, a, r = !0) => await n(t, "get", a, r),
    /** 导出文件,post方法 */
    exportFilePost: async (t, a, r = !0) => await n(t, "post", a, r),
    /** axios源生请求方法，用于处理无法覆盖到的接口 */
    request: async (t) => await e(t)
  };
}, w = l;
export {
  w as default
};
